import { api } from "@state/apiSlice";
import { Tags } from "@state/apiSlice/tags";
import { Message } from "@hz/common/api-types/index";

const itemRequestsSlice = api.injectEndpoints({
  endpoints: (build) => ({

    updateMerchantId: build.mutation<Message, {merchantId: string}>({
      query: ({merchantId}) => ({
        url: "/item/update-merchant-id",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: {
          merchantId,
        },
      }),
      // invalidatesTags: [{ type: Tags.ConnectionStatus }],
    }),
  }),
});

export default itemRequestsSlice;
